import Grid from "@material-ui/core/Grid";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ContactsRemove from "../../components/contacts/ContactsRemove";

const useStyles = makeStyles(theme => ({
  overflowHidden: {
    overflow: "hidden"
  }
}));

const Removal = () => {
  const classes = useStyles();

  return (
    <Grid container spacing={0} className={classes.overflowHidden}>
      <Grid item xs={12}>
        <ContactsRemove />
      </Grid>
    </Grid>
  );
};

export default Removal;
